module.exports = __webpack_public_path__ + "assets/img/3.6c17df4e.svg";